import { Controller } from "@hotwired/stimulus";

// Ask question boxes.
//
// Enter sends, Shift+Enter starts a new line. Enter that confirms a
// character while typing Japanese, Chinese or Korean (an IME) doesn't send:
// isComposing catches it, and keyCode 229 catches Safari, which reports
// that Enter after composition has ended.
//
// As soon as the question is sent, the pending template (the question as a
// bubble, and "Searching the archive…") is shown in the element matching
// +into+ (appended, or replacing its content), so nothing waits on the
// server; its reply then replaces the chat pane.
export default class extends Controller {
  static targets = ["pending", "question"];
  static values = { into: String, mode: { type: String, default: "append" } };

  submit(event) {
    if (event.shiftKey) return;
    event.preventDefault();
    if (event.isComposing || event.keyCode === 229) return;
    this.element.requestSubmit();
  }

  showPending() {
    const into = this.hasIntoValue && document.querySelector(this.intoValue);
    if (!into || !this.hasPendingTarget) return;

    const pending = this.pendingTarget.content.cloneNode(true);
    pending.querySelectorAll("[data-slot=question]").forEach((slot) => { slot.textContent = this.questionTarget.value.trim(); });
    if (this.modeValue === "replace") into.replaceChildren(pending);
    else into.append(pending);
    if (this.modeValue === "append") this.questionTarget.value = "";
  }
}
